var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.typeId > 0
    ? _c("div", [
        _c(
          "button",
          {
            staticClass: "btn btn-light btn-sm",
            attrs: { type: "button" },
            on: { click: _vm.goToVariations },
          },
          [_vm._v("\n        " + _vm._s(_vm.formattedValue) + "\n    ")]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }